import useTitle from "../../hooks/useTitle"
import PulseLoader from 'react-spinners/PulseLoader'
import { useNavigate, useParams, useLocation, Link } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFlag, faPenToSquare } from "@fortawesome/free-solid-svg-icons"
import {  useGetGlobalSearchMutation } from "../responses/responsesApiSlice"
import getFilePath from "../../utils/getFilePath"
import { useEffect } from "react"
import useQueryParams from "../../hooks/useQueryParams"

const GradesGlobalFindList = () => {
    const {groupId,  taskId, type} = useParams()
    const navigate = useNavigate() 
    const { q, qName } = useQueryParams()
    useTitle('geshtop-Exercise: Grades List')
    const[ getDataQuery, {
        data: responses,
        isLoading,
        isSuccess,
        isError,
        error
    }] = useGetGlobalSearchMutation()


    useEffect(()=>{
        getDataQuery({q, groupId, taskId,qName})
    },[q, qName])
     let content
    if (isLoading ) content = <PulseLoader color={"#FFF"} />

    if (isError) {
        content = <p className="errmsg">{error?.data?.message}</p>
    }
    const handleShow = (taskId,responseId) =>  navigate(`/${type}/${groupId}/grades/task/${taskId}/${responseId}?q=${encodeURIComponent( q)}&qName=${encodeURIComponent(qName)}`)
    if (isSuccess  ) {
      
        
        // const temResponse = responses.map(response=>{
        //     const newResponse = {...response}
        //     newResponse.responseCombinedText = JSON.stringify(response.body).toLowerCase() + JSON.stringify(response.additions).toLowerCase()
        //     return newResponse
        // })
       
        // const filterResponse =temResponse.filter(response=>{
        //     return (
        //         (groupId==='0' || response.group === groupId) &&
        //         (filter?.q==='' || response.responseCombinedText.indexOf(filter?.q) > -1) &&
        //         (filter?.qName==='' || (response.fullname.indexOf(filter?.qName) > -1|| response.username.indexOf(filter?.qName) > -1))
        //     )
        // })
        
        //groupId!=='0'? responses.filter(res=>res.group===groupId) : [...responses]
        const tableContent = responses.map((response, key) => {
            const grade = response.grade || -1;
            return(
            <tr className="table__row" key={`table-action-${key}`} >
                <td className="table__cell response__text"> {key}. {response.updated &&<FontAwesomeIcon icon={faFlag} />} {response.username}</td>
                <td className="table__cell response__text"><span className="d-flex">
                    {response.fullname}
                    {response.userImage && <div className='profile-image' style={{backgroundImage:`url(${getFilePath(response.userImage)})`}}></div>}
                    </span>
                    </td>
                    <td className="table__cell response__text">
                        {response.group_model?.name}  | {response.group_model?.year}
                    </td>
                <td className="table__cell response__text"> <Link style={{color:"Black"}} target="_blank" to={`/${type}/${groupId}/grades/task/${response.task._id}`}> {response.task.title}</Link></td>
                <td className="table__cell response__text">{response.comments}</td>
                {/* <td className="table__cell response__text">{response.responseAt}</td> */}

                <td className="table__cell action__status">
                    {grade > -1
                    ? <span className="status--completed">{grade}</span>
                    : <span className="status--open">לא ניתן ציון</span>
                    } 
                </td>
                {/* <td className="table__cell response__text">{response.gradeBy}</td> */}

                <td className="table__cell">
                   { <button
                        className="icon-button table__button"
                        onClick={()=>handleShow(0,response._id)}
                    >
                        <FontAwesomeIcon icon={faPenToSquare} />
                    </button> }
               
                  
                </td>
            </tr>
            )
        }
        
        
            )

        content = (
            <>
             <div className="filter-form wrap">
           <h2>תרגילים חיפוש גלובלי</h2>
          
            </div>
          
            <table className="table table--admin-grades">
                <thead className="table__thead">
                    <tr>
                        <th scope="col" className="table__th admin-grades--user__username">Username</th>
                        <th scope="col" className="table__th admin-grades--user__name">שם</th>
                        <th scope="col" className="table__th admin-grades--user__name">קבוצה</th>
                        <th scope="col" className="table__th admin-grades--user__name">משימה</th>
                        <th scope="col" className="table__th admin-grades--user__email">הערות</th>
                        {/* <th scope="col" className="table__th user__phone">הוגש בתאריך</th> */}
                        <th scope="col" className="table__th admin-grades--user__groups">ציון</th>                      
                        {/* <th scope="col" className="table__th user__roles">ע"י</th> */}
                        <th scope="col" className="table__th admin-grades--user__edit">#</th>
                    </tr>
                </thead>
                <tbody>
                    {tableContent }
                </tbody>
            </table>
            </>
        )
    }

    return content
}
export default GradesGlobalFindList